<template>
  <div class="nodeBox" :class="{ 'selectedBox': this.selected }">
    <NodeHeader :title="this.data.label" :hook="this.data.hook" :icon="null" />
    <Handle
      type="target"
      position="left"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <!-- <p>{{ this.data.text }}</p> -->
    <div v-if="this.data.type == 'crm_output'">
      <!-- <img :src="this.img_src" /> -->

      <Select
        :items="['Table 1', 'Table 2', 'Table 3']"
        :title="'Select table'"
      />
    </div>
  </div>
</template>

<script>
import { Handle } from "@vue-flow/core";
import Select from "../inputs/Select.vue";
import NodeHeader from "./NodeComponents/NodeHeader.vue";

export default {
  name: "InputNode",
  props: {
    selected: Boolean,
    data: Object,
    // title: String,
    // text: String,
  },
  components: {
    Handle,
    Select,
    NodeHeader,
  },
  data() {
    console.log(this.data);
    console.log(this.selected);
    console.log(this.data.label);
    return {};
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
</style>
